import React from "react";
import { Outlet } from "react-router-dom";
// import { Sidebar } from "../../components/Sidebar";
import Header from "../../components/Header";
import Breadcrumb from "../../components/breadcrumb";
import { useSingleTabGuardStatus } from "../../helper/singleTabGuard";
const AdminLayout: React.FC = () => {
 const { blocked: isBlocked, ready } = useSingleTabGuardStatus();

  if (!ready || isBlocked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="p-6 rounded-lg shadow bg-white text-center">
          <h1 className="text-lg font-semibold text-gray-900">
            App already open in another tab
          </h1>
          <p className="mt-2 text-sm text-gray-600">
            Please use the original tab. This tab is blocked.
          </p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="flex flex-col h-screen bg-white dark:bg-gray-800 ">
      <Header menuName="admin" />

      <div className="flex-1 overflow-y-auto">
        <div className="bg-white mx-auto border-t border-gray-50 dark:border-gray-800 text-gray-800 dark:text-gray-200 dark:bg-gray-900  space-x-4  py-4 px-4 sm:px-6 lg:px-8  z-50 backdrop-blur-md">
          <Breadcrumb />
        </div>
        <div className="space-x-1 mx-auto py-6 px-4 m-1 sm:px-4 lg:px-4 bg-white dark:bg-gray-800 2xl:container border border-gray-50 dark:border-gray-700 rounded-lg ">
          {/* <div className='bg-white shadow-md sm:rounded-lg p-4 h-full'> */}
          <Outlet />
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
